var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4168 7.52295C14.6287 5.89057 12.3697 5 10.0074 5C7.63811 5 5.37282 5.89589 3.58252 7.53709L3.43047 7.67647C3.30752 7.78918 3.30046 7.98954 3.41514 8.11176L4.46959 9.23558C4.57194 9.34466 4.7356 9.3521 4.84629 9.25271L4.97692 9.13542C6.38685 7.86943 8.15705 7.18036 10.0074 7.18036C11.8514 7.18036 13.616 7.86472 15.0238 9.12284L15.1544 9.23953C15.2651 9.33848 15.4284 9.33085 15.5306 9.22195L16.5852 8.09798C16.7 7.97558 16.6928 7.77488 16.5694 7.66228L16.4168 7.52295ZM10.0074 8.46985C11.4959 8.46985 12.925 8.99759 14.0893 9.97492L14.2538 10.113C14.385 10.2232 14.3965 10.4306 14.2784 10.5565L13.2204 11.6841C13.1225 11.7884 12.9677 11.8004 12.8567 11.7123L12.7278 11.6098C11.9414 10.9852 10.9933 10.6502 10.0074 10.6502C9.01541 10.6502 8.06169 10.9894 7.27275 11.6212L7.14365 11.7245C7.03267 11.8134 6.87726 11.8017 6.77911 11.6971L5.72146 10.5699C5.60363 10.4443 5.61482 10.2373 5.74539 10.127L5.909 9.98877C7.07602 9.00273 8.51168 8.46985 10.0074 8.46985ZM10.0074 11.9395C10.6057 11.9395 11.1871 12.1075 11.6994 12.428L11.907 12.5578C12.0644 12.6562 12.092 12.8866 11.963 13.0241L10.1908 14.9129C10.0819 15.0289 9.90544 15.0289 9.79658 14.9129L8.03573 13.0362C7.90727 12.8993 7.93405 12.6701 8.09008 12.571L8.29532 12.4406C8.81232 12.112 9.40111 11.9395 10.0074 11.9395Z",
    fill: "#66BB6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.09087c6a64b11005ecf6ac99c0ae6496.svg";
export { ForwardRef as ReactComponent };